'use client';
import RequestDemoModal from '@/components/_rebrand/RequestDemo/RequestDemoModal';
import { OPTIMIZELY_PAGES } from '@/constants/optimizely';
import optimizely from '@/lib/optimizely';
import useStore from '@/stores/useStore';
import { useRouter } from 'next/navigation';
import { FC, useEffect } from 'react';

interface DemoModalProps {
  onClose?: () => void;
}

const DemoModal: FC<DemoModalProps> = () => {
  const { isDemoModalOpen, setDemoModalOpen } = useStore();

  const router = useRouter();

  useEffect(() => {
    if (isDemoModalOpen) {
      const deactivate1 = optimizely.activatePage(OPTIMIZELY_PAGES.ANY_GET_STARTED_MODAL);
      const deactivate2 = optimizely.activatePage(OPTIMIZELY_PAGES.DEMO_MODAL);

      return () => {
        deactivate1();
        deactivate2();
      };
    }
  }, [isDemoModalOpen]);

  return isDemoModalOpen ? (
    <RequestDemoModal onClose={() => setDemoModalOpen(false)} />
  ) : null;
};

export default DemoModal;
